import React from 'react';
import { Clock } from 'lucide-react';
import { useCountdown } from './BonusSection';
export function StickyTimer() {
  const {
    minutes,
    seconds,
    isExpired
  } = useCountdown();
  if (isExpired) return null;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white" data-id="element-254">
      <div className="flex items-center justify-center gap-2 py-2 px-4 text-xs sm:text-sm" data-id="element-255">
        <Clock className="w-3.5 h-3.5 flex-shrink-0" data-id="element-256" />
        <span className="font-medium" data-id="element-257">Bonus gratis disponibles por:</span>
        <span className="font-mono font-bold text-sm sm:text-base" data-id="element-258">
          {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
        </span>
      </div>
    </div>;
}